import { motion, useScroll, useSpring } from "framer-motion";

export default function ReadingProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 30, mass: 0.4 });
  return (
    <motion.div
      aria-hidden="true"
      data-testid="reading-progress"
      className="pointer-events-none fixed inset-x-0 top-0 z-[95] h-[2px] origin-left bg-umber"
      style={{ scaleX }}
    />
  );
}
